"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_CAPACITY = exports.DEFAULT_CIRCUIT_CONFIG = exports.MAX_SOLIDITY_MAPPING_KEYS = exports.SUBQUERY_FE = exports.MAX_SUBQUERY_OUTPUTS = exports.MAX_SUBQUERY_INPUTS = exports.MAX_DATA_SUBQUERIES = exports.MAX_USER_OUTPUTS = exports.USER_OUTPUT_FE = void 0;
const tools_1 = require("@axiom-crypto/tools");
exports.USER_OUTPUT_FE = tools_1.AxiomV2CircuitConstant.UserResultFieldElements;
exports.MAX_USER_OUTPUTS = tools_1.AxiomV2CircuitConstant.UserMaxOutputs;
exports.MAX_DATA_SUBQUERIES = tools_1.AxiomV2CircuitConstant.UserMaxSubqueries;
exports.MAX_SUBQUERY_INPUTS = tools_1.AxiomV2CircuitConstant.MaxSubqueryInputs;
exports.MAX_SUBQUERY_OUTPUTS = tools_1.AxiomV2CircuitConstant.MaxSubqueryOutputs;
exports.SUBQUERY_FE = (1 + exports.MAX_SUBQUERY_INPUTS + exports.MAX_SUBQUERY_OUTPUTS);
exports.MAX_SOLIDITY_MAPPING_KEYS = tools_1.AxiomV2CircuitConstant.MaxSolidityMappingKeys;
exports.DEFAULT_CIRCUIT_CONFIG = {
    k: 14,
    numAdvice: tools_1.AxiomV2CircuitConstant.UserAdviceCols,
    numLookupAdvice: tools_1.AxiomV2CircuitConstant.UserLookupAdviceCols,
    numInstance: tools_1.AxiomV2CircuitConstant.UserInstanceCols,
    numLookupBits: 13,
    numVirtualInstance: 2,
};
exports.DEFAULT_CAPACITY = {
    maxOutputs: tools_1.AxiomV2CircuitConstant.UserMaxOutputs,
    maxSubqueries: tools_1.AxiomV2CircuitConstant.UserMaxSubqueries,
};
//# sourceMappingURL=constants.js.map